<template lang="pug">
  header#page-header(:class="stickyHeaderClass")
    .header-regions-wrapper
      .l-meta-navigation-outer.container
        .l-region.l-region--meta-navigation
          .block--menu-menu-metamenu
            CDUCustomers(type="headerSocial")
      .l-branding-outer.container
        .l-branding
          .site-name-box.site-slogan-box
              h1.site-name
                span(:is="logoWrap" v-bind="logoWrapProps")
                  CDUCustomers(type="headerTitle")
              h2.site-slogan
                CDUCustomers(type="headerSlogan")
      .l-logo
        .cdu-logo
          CDUCustomers(type="headerCDULogo")
    .l-navigation-outer
      .container
        .sticky-mobile-bar
          button.hamburger.hamburger--3dy(
            type="button"
            :class="{ 'is-active': sidebar }"
            @click="toggleSidebar"
          )
            font-awesome-icon(:icon="['fas', 'bars']")
        Menu#main-menu(k="main-menu" :max-depth="3")
</template>

<script>
import { mapGetters, mapMutations } from 'vuex';

import Menu from '@/components/Menu.vue';
import CDUCustomers from '@/components/CDUCustomers.vue';

export default {
    name: 'Header',
    data: () => ({
        lastScroll: 0,
        stickyHeaderClass: ''
    }),
    components: {
        Menu,
        CDUCustomers
    },
    computed: {
        url() {
            let url = window.location.href;
            let domain = new URL(url);
            domain = domain.hostname;
            return domain;
        },
        logoWrap() {
            let tag = 'span';
            if (this.$route.path !== '/') {
                tag = 'a';
            }
            return tag;
        },
        logoWrapProps() {
            let props = {};
            if (this.$route.path !== '/') {
                props = { href: '/' };
            }
            return props;
        },
        ...mapGetters({
            menus: 'menus',
            sidebar: 'sidebar'
        })
    },
    methods: {
        toggleSidebar() {
            this.updateSidebarVisibility(!this.sidebar);
        },

        updateStickyHeader() {
            const currentScroll = window.pageYOffset;

            const scrollUp = 'scroll-up';
            const scrollDown = 'scroll-down';

            if (currentScroll > this.lastScroll && this.stickyHeaderClass !== scrollDown) {
                this.stickyHeaderClass = scrollDown;
            } else if (currentScroll < this.lastScroll && this.stickyHeaderClass !== scrollUp) {
                this.stickyHeaderClass = scrollUp;
            }

            this.lastScroll = currentScroll;
        },
        ...mapMutations({
            updateSidebarVisibility: 'updateSidebarVisibility'
        })
    },
    mounted() {
        window.addEventListener('scroll', this.updateStickyHeader);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.updateStickyHeader);
    }
};
</script>

<style lang="sass" nolang="scss" scoped>
@import "~@/assets/sass/variables"

header
  background-color: $color-primary
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.1)
  .header-regions-wrapper
    @apply relative
    height: 140px
    @screen sm
      height: 157px
    &:before
      @apply h-full top-0 left-0 absolute bg-no-repeat
      background-image: url('~@/assets/img/header-verlauf.png')
      background-position: 60% 30%
      background-size: auto 80%
      width: 100%
      content: ""
      z-index: 1
      @screen sm
        width: 70%
      @screen lg
        width: 70%
        height: 100%
        background-size: auto
        background-position: right 50%
      @media screen and (min-width:2140px)
        background-size: 100%
    .l-meta-navigation-outer
      @apply z-20 relative
      height: 46px
      @screen sm
        @apply mx-auto
      .l-region--meta-navigation
        @apply float-left
        @screen sm
          @apply float-right

    .l-branding-outer
      @apply z-20 relative
      @screen md
        @apply mx-auto
      .site-name-box
        @apply py-4
        .site-name
          > span, > a
            @apply inline-block bg-white text-base leading-5
            padding: 5px 8px
            @screen sm
              @apply leading-normal text-2xl
            @screen md
              @apply leading-10
              font-size: 2rem

        .site-slogan span
            @apply inline-block text-white mt-1 text-sm
            padding: 3px 8px
            line-height: 1.2
            background-color: $color-secondary
            @screen sm
              @apply text-sm
              line-height: 1.2
            @screen md
              @apply text-base
    .l-logo::v-deep
      .cdu-logo
        @apply absolute right-0 z-20
        top: 12px
        @screen sm
          top: 62px
        img
          max-height: 30px
          @screen sm
            max-height: 46px
          @screen md
            max-height: 50px

  .l-navigation-outer
    @apply bg-white
    .container
      @screen md
        @apply mx-auto


  .sticky-mobile-bar
    @apply left-0 z-10 text-black
    height: 46px

    .hamburger
      @apply rounded-md text-2xl
      margin-top:7px
      padding: 0
      line-height: 38px
      font-size: 24px
      background-color: $color-primary
      height: 33px
      width: 33px
      color: #fff
    @screen md
      @apply hidden


  #main-menu
    @apply hidden
    height: 40px
    @screen md
      @apply block
      height: 46px
    &::v-deep
      ul
        @apply hidden
        @screen md
          @apply flex
        .full-width > ul
          columns: 2
        &.tree-menu
          & > li
            @apply relative transition duration-300 ease-linear ml-6
            line-height: 46px
            &:first-child
              margin-left: 0 !important
            & > .tree-item a
              @apply flex uppercase
              height: 46px
              .svg-inline--fa
                width: 11.2px !important
                height: auto !important
                color: $color-secondary
                padding-right: 0
                margin-left: 8px
              &:hover
                color: $color-secondary
                border-bottom: 5px solid $color-secondary
          & > li.active a, li.hover a
            color: $color-secondary
            border-bottom: 5px solid $color-secondary
            .svg-inline--fa
              margin-bottom: -5px
      & > ul
        &.tree-menu
          & > li
            & > ul
              @apply bg-white border border-solid
              border-color: #dad9d4
              li
                margin-left: 0
                &.has-children > .tree-item > a
                  padding-right: 1.25em
                &:last-child a
                  @apply border-0
                  &:hover
                    @apply border-0
              & > li.active > .tree-item > a
                color: $color-secondary
              &.tree-menu
                @apply absolute left-0 inline-block
                top: 46px
                z-index: 100
                min-width: 12em
                a
                  @apply text-black leading-none h-auto border-b border-solid normal-case
                  border-color: #dad9d4
                  padding: 0.625em
                  font-size: 14.4px
                  .fa-angle-down
                    @apply absolute
                    right: 0.313rem
                    top: 0.375rem
                    color: $color-base-text
                    transform: rotate(-90deg)
                  &:hover
                    @apply border-b border-solid
                    border-color: #dad9d4
          ul ul
            @apply absolute top-0 bg-white border border-solid inline-block
            min-width: 12em
            left: 100%
            & > li.active > .tree-item > a
              color: $color-secondary

      .show-enter-active, .show-leave-active
        transition: opacity 0.3s ease, transform 0.3s ease
        transform-origin: left center
      .show-enter, .show-leave-to
        opacity: 0
        transform: translateY(6px)
</style>
